import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getCurrentUid from '../utilities/getCurrentUid'
import Thing from '../utilities/Data/Thing'
import maybe from '../utilities/maybe'

const removeDuplicates = arr => [...(new Set(arr))]

const getKitOwnWants = async ({ stateKitOwnById = {}, kit, kits, kitsOwned, kitsWanted, result, feed, posts, post }) => {
	try {
		// get to the entities in whatever was passed in
		const searchedKits = (result && result.hits) || [] // TODO: sagafy search and won't need this
		const allPosts = [...(feed || []), ...(posts || []), ...maybe([post], post)]
		const taggedKits = allPosts
			.reduce((tags, p) => [...tags, ...p.tags], [])
			.filter(Thing.isKit)

		// from all of the kits passed in, get the unique kitIds
		const allKits = [
			...maybe([kit], kit), // kitFetch_Success, kitDraftFetch_Success
			...maybe(kits, kits), // userProfileKitsFetch_Success
			...maybe(kitsOwned, kitsOwned), // userProfileKitsOwnedFetch_Success
			...maybe(kitsWanted, kitsWanted), // userProfileKitsWantedFetch_Success
			...maybe(searchedKits, searchedKits), // SEARCH_KIT_SUCCESS
			...maybe(taggedKits, taggedKits.length) // feedFetch_Success, userProfilePostsFetch_Success, postFetch_Success
		]
		const kitIds = removeDuplicates(allKits.map(k => k.kitId))
			.filter(kitId => stateKitOwnById[kitId] === undefined) // filter out any we already have data for

		// request the data
		const uid = getCurrentUid()
		const ownerDocSnaps = await Promise.all(kitIds.map(async kitId => firestore.collection('kits').doc(kitId).collection('owners').doc(uid).get()))
		const wanterDocSnaps = await Promise.all(kitIds.map(async kitId => firestore.collection('kits').doc(kitId).collection('wanters').doc(uid).get()))

		// provide data by kitId
		const kitOwnById = kitIds.reduce((owns, kitId, i) => ({
			...owns,
			[kitId]: ownerDocSnaps[i].exists && ownerDocSnaps[i].data()
		}), {})
		const kitWantById = kitIds.reduce((wants, kitId, i) => ({
			...wants,
			[kitId]: wanterDocSnaps[i].exists && wanterDocSnaps[i].data()
		}), {})

		return { kitOwnById, kitWantById }
	} catch (error) {
		console.log(error)
		throw errorOfType(errorTypes.UNKNOWNERROR, error)
	}
}

export default getKitOwnWants



// WEBPACK FOOTER //
// ./src/dataservices/getKitOwnWants.js